export const environment = {
	production: true,
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	// api_url: 'https://dev.kaspontech.com/djadmin/'  ,           // Fieldpro live URL
 	// api_url: 'https://dev.kaspontech.com/djadmin-qa/',	     // Fieldpro Dev URL
	//  api_url: 'https://dev.kaspontech.com/djadmin-newui/',	 // Dev customer webform URL
	// api_url: 'https://app.kaspontech.com/djadmin-qa/',
	// api_url: 'https://app.kaspontech.com/fpadmin/',
	// api_url: 'https://app.kaspontech.com/djadmin-qa/',  // QA URL
	// api_url: 'https://app.kaspontech.com/acadmin-qa/',
	api_url: 'https://app.kaspontech.com/acadmin/',
	// api_url:'https://app.kaspontech.com/fpadmin/',
	// api_url: 'https://fieldproproduct.kaspontech.com/fpadmin/',  // Production URL
	image_static_ip: "https://app.kaspontech.com/",

};
